'use client'

import { useEffect, useRef } from 'react'

// Renders the scoped, ported industry widget-gallery HTML and wires the
// lightbox in React (the design's inline <script> is inert when injected via
// innerHTML, so the interaction lives here instead). All visual styles are
// scoped under `.iwg` by the renderer, so nothing leaks into the host page.
export function IndustryWidgetGallery({ html }: { html: string }) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const root = ref.current
    if (!root) return
    const lb = root.querySelector('#lb') as HTMLElement | null
    if (!lb) return

    const close = () => lb.classList.remove('on')
    const closers = Array.from(lb.querySelectorAll('[data-x]'))
    closers.forEach((b) => b.addEventListener('click', close))

    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close()
    }
    document.addEventListener('keydown', onKey)

    const onClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement
      const t = target.closest('.tile.post') as HTMLElement | null
      if (!t || target.closest('.hot')) return
      const set = (sel: string, txt: string) => {
        const el = lb.querySelector(sel) as HTMLElement | null
        if (el) el.textContent = txt
      }
      const img = t.querySelector('img') as HTMLImageElement | null
      const media = lb.querySelector('.lb-media img') as HTMLImageElement | null
      if (media) media.src = img ? img.currentSrc || img.src : ''
      set('.lb-handle', t.dataset.handle || 'Creator')
      set('.lb-plat', `${t.dataset.plat || 'UGC'} · tagged post`)
      const cap = lb.querySelector('.lb-cap') as HTMLElement | null
      if (cap) {
        cap.textContent = t.dataset.caption || ''
        cap.style.display = t.dataset.caption ? 'block' : 'none'
      }
      const prod = lb.querySelector('.lb-prod') as HTMLElement | null
      if (prod) {
        // dataset values come from our own trusted industry JSON, not user input
        prod.innerHTML = t.dataset.product ? `<div class="lb-pchip">${t.dataset.product}</div>` : ''
      }
      set('.lb-cta', t.dataset.cta || 'View product')
      lb.classList.add('on')
    }
    root.addEventListener('click', onClick)

    return () => {
      closers.forEach((b) => b.removeEventListener('click', close))
      document.removeEventListener('keydown', onKey)
      root.removeEventListener('click', onClick)
    }
  }, [html])

  return <div ref={ref} dangerouslySetInnerHTML={{ __html: html }} />
}
